import type { FC } from "react";

const INPUT_CLASS =
  "block w-full rounded-md border-0 py-1.5 px-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm disabled:bg-gray-50";

export const TextField: FC<{
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  type?: string;
  placeholder?: string;
  list?: string;
  hint?: string;
  disabled?: boolean;
}> = ({
  id,
  label,
  value,
  onChange,
  type = "text",
  placeholder,
  list,
  hint,
  disabled,
}) => (
  <div>
    <label htmlFor={id} className="block text-sm font-medium text-gray-900">
      {label}
    </label>
    <input
      id={id}
      type={type}
      value={value}
      placeholder={placeholder}
      list={list}
      disabled={disabled}
      autoComplete={type === "password" ? "new-password" : "off"}
      onChange={event => onChange(event.target.value)}
      className={`mt-1 ${INPUT_CLASS}`}
    />
    {hint && <p className="mt-1 text-xs text-gray-500">{hint}</p>}
  </div>
);

export const SelectField: FC<{
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: { value: string; label: string }[];
  placeholder?: string;
}> = ({ id, label, value, onChange, options, placeholder }) => (
  <div>
    <label htmlFor={id} className="block text-sm font-medium text-gray-900">
      {label}
    </label>
    <select
      id={id}
      value={value}
      onChange={event => onChange(event.target.value)}
      className={`mt-1 ${INPUT_CLASS}`}>
      {placeholder !== undefined && <option value="">{placeholder}</option>}
      {options.map(option => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  </div>
);

export const SectionHeading: FC<{
  id: string;
  title: string;
  description?: string;
}> = ({ id, title, description }) => (
  <div>
    <h3 id={id} className="text-base font-semibold text-gray-900">
      {title}
    </h3>
    {description && <p className="mt-1 text-sm text-gray-500">{description}</p>}
  </div>
);
